// extracted by mini-css-extract-plugin
export var editButton = "_o0-0";